import { useChatTabsStore } from '../../../store/chatTabsStore';
import { useConversationsStore } from '../../../store/conversations-store';

export const switchToChatTab = ({ tabId }: { tabId: string }) => {
  const { chatTabs, setActiveChatTabId } = useChatTabsStore.getState();
  const { setActiveConversation } = useConversationsStore.getState();
  const tab = chatTabs.find((tab) => tab.tabId === tabId);
  if (!tab) {
    return;
  }

  setActiveChatTabId(tabId);
  setActiveConversation(tab.conversationId ?? null);
};
